import React from 'react';
import { useDevelopmentDemo } from '../../contexts/DevelopmentDemoContext';
import { focusRing } from '../../utils/demoUi';
import { deriveStage } from '../../utils/developmentDemo';
import { StageBadge } from './DevBadges';

/** Selects the record shown in a reviewer section. */
export function ParticipantPicker() {
  const {
    state,
    config,
    dispatch
  } = useDevelopmentDemo();
  return <div role="group" aria-label={`Choose a ${config.participantNoun.toLowerCase()} record`} className="mb-6 flex flex-wrap gap-2" data-id="element-829" data-mp="azmcht1bsapl">
      {config.participants.map(participant => {
      const active = participant.id === state.ui.selectedParticipantId;
      return <button key={participant.id} type="button" aria-pressed={active} onClick={() => dispatch({
        type: 'selectParticipant',
        id: participant.id
      })} className={`flex items-center gap-3 rounded-xl border px-4 py-2.5 text-left transition-colors duration-150 ${focusRing} ${active ? 'border-navy bg-white shadow-premium' : 'border-line bg-white/60 hover:bg-white'}`} data-id="element-830" data-mp="kvpff1404ddl">
            <span className="font-semibold text-ink-dark" data-id="element-831" data-mp="3tumc6x7er7uu">{participant.name}</span>
            <StageBadge stage={deriveStage(state, participant.id)} data-id="element-832" data-mp="2qxqvnzfzswt" />
          </button>;
    })}
    </div>;
}